const baseUrl = 'https://archive.org/metadata/';

export async function fetchItem(item) {
	const res = await fetch(`${baseUrl}${item}`);
	const json = await res.json();

	if (res.ok) {
		return json;
	} else {
		throw new Error(json);
	}
}

export async function fetchConfig() {
	const res = await fetch(`config.json`);
	const json = await res.json();

	if (res.ok) {
		return json;
	} else {
		throw new Error(json);
	}
}

export async function fetchFeeds(){
    const config = await fetchConfig()
    const items = config.feeds?config.feeds:[]
    return Promise.all(items.map((item) => {
            return fetchItem(item)
        })
    );
}